module.exports = __webpack_public_path__ + "img/sant.eef518b0.jpg";